<template>
	<b-container class="text-left tb-margin">
	  <b-row class="mb-3" align-h="center">
	    <b-col class="top-title" sm="12" md="6">
	    	{{ $t('pass-forget') }}
	    </b-col>
	  </b-row>

	  <b-row class="mb-4" align-h="center">
	    <b-col sm="12" md="6">
	    	<span style="font-weight:300">{{ $t('email') }}</span><br>
			<b-form-input size="sm" type="text" v-model="email" @keyup.enter="forgotPassword()" :placeholder="$t('email-enter')"></b-form-input>
	    </b-col>
	  </b-row>
	  <b-row v-if="error" class="mb-3 text-center" align-h="center">
	    <b-col sm="12" md="6">
		  <div class="gera-btn red-btn cursord">{{ $t('error') }}: {{error}}</div>
	    </b-col>
	  </b-row>
	  <b-row v-if="message" class="mb-3 text-center" align-h="center">
	    <b-col sm="12" md="6">
		  <div class="gera-btn green-btn cursord">{{message}}</div>
	    </b-col>
	  </b-row>
	  <b-row class="mb-3 text-center" align-h="center">
	    <b-col sm="12" md="6">
		  <div v-if="!logging" class="gera-btn pt-3 pb-3" @click="forgotPassword()">{{ $t('get-new-pass')}}</div>
 		  <div v-else class="text-center">
			<b-spinner variant="primary"></b-spinner>
		  </div>
	    </b-col>
	  </b-row>
	  <b-row class="mb-3 text-center" align-h="center">
	    <b-col sm="12" md="6">
		  <div class="gera-btn green-btn" @click="backToLogin()">{{ $t('back-to-login')}}</div>
	    </b-col>
	  </b-row>
	</b-container>
</template>
<script>
import api from '@/components/backend-api';
export default {
  name: "passwordForget",
  props: {
  },
  data () {
    return {
    	focused: true,
    	logging: false,
		email: '',
		error: null,
		message: null
    }
  },
/*
  mounted(){
  	this.focused: true,
  },
*/
  methods: {
  	backToLogin () {
  		this.$emit('backToLogin');
  	},
  	forgotPassword () {
	  
	  if (this.email.trim() == '') return false;
	  
	  if (this.isEmailValid()){
	    this.error = null;
	    this.message = null;
		this.logging = true;

		api.executePostServerAction('/auth/passwordForget/', { email: this.email.trim() })
		// api.forgetPassword({ email: this.email.trim() })
			.then(response => {
				this.logging = false;
				console.log('Response:');
				console.log(response);
				this.message = response.data.message;
				this.email = '';
				// if (response.data.data.length>0) this.member = response.data.data[0];
			})
			.catch(error => {
				this.logging = false;
				console.log('Save profile error!');
				console.log('Error: ' + error);
				console.log(error.response);
	            this.error = error.response.data.message;
			})


/*
			this.$store.dispatch('forgetPassword', { email: this.email.trim() })
	        .then(() => {
	          // this.$router.push('/intranet')
		      this.logging = false;
	        })
	        .catch(error => {
		      this.logging = false;
	          this.errors.push(error);
	          this.error = true;
	        })
*/
	  }
	},
	isEmailValid () {
	  const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;
	  // const matches = regex.exec(this.email);
      return (this.email == "")? "" : (regex.exec(this.email)) ? true : false;
    },
  }
};
</script>
<style>
	.red-btn {
		background-color:darkred !important;font-size:0.9em !important;
	}
	.green-btn {
		background-color:green !important;font-size:0.9em !important;
	}
</style>
<i18n>
	{
		"sl": {
			"change-pass": "Spremeni geslo",
			"new-pass": "Novo geslo",
			"confirm-pass": "Potrdi geslo",
			"pass-anf": "Prijavili ste se z enkratnim geslom.<br>Iz varnostnih razlogov morate spremeniti geslo.",
			"set-new-pass": "Nastavi novo geslo",
			"cancel": "Prekliči",

			"pass-forget": "Pozabil sem geslo",
			"email": "Elektronski naslov",
			"email-enter": "Vpišite vaš elektronski naslov",
			"get-new-pass": "Zahtevaj novo geslo",
			"back-to-login": "Nazaj na prijavo",
			"error": "Napaka"
		},
		"de": {
			"change-pass": "Passwort endern",
			"new-pass": "Neues Passwort",
			"confirm-pass": "Passwort bestätigen",
			"pass-anf": "Sie haben sich mit einem einmaligen Passwort angemeldet.<br>Aus Sicherheitsgründen müssen sie Ihr Passwort ändern.",
			"set-new-pass": "Neues Passwort stellen",
			"cancel": "Abbrechen",

			"pass-forget": "Passwort vergessen ",
			"email": "Email",
			"email-enter": "Email eingeben",
			"get-new-pass": "Neues Passwort anfordern",
			"back-to-login": "Zurück zu Login",
			"error": "Fehler"
		},
		"en": {
			"change-pass": "Change password",
			"new-pass": "New password",
			"confirm-pass": "Confirm password",
			"pass-anf": "You have registered with a one-time password.<br>For security reasons, you must change your password.",
			"set-new-pass": "Set new password",
			"cancel": "Cancel",

			"pass-forget": "Forgot password",
			"email": "Email",
			"email-enter": "Enter email address",
			"get-new-pass": "Get new password",
			"back-to-login": "Back to login",
			"error": "Error"
		}
	}
</i18n>
